export default __webpack_public_path__ + "static/media/benefit_6@2x.0397b2d8.png";